import axios from '@/api/axios';
import type {AdminPaginatedEnvelope, AfriexQueryParams} from '@/types';
import type {AppUsageEvent} from '@/types/attribution';
import {AttributionEventType} from '@/types/attribution';

interface AttributionParams {
  startDate: string;
  endDate: string;
}

interface AppUsageHistoryParams extends AfriexQueryParams {
  events?: AttributionEventType[];
  email?: string;
  userId?: string;
}

type AttributionResponse = {
  [K in AttributionEventType]: number;
};

export const attributionService = {
  getAttributionData: async (
    params: AttributionParams,
  ): Promise<AttributionResponse> => {
    const {data} = await axios.get<AttributionResponse>(
      `/v2/admin/users/attribution`,
      {
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          eventTypes: 'install',
        },
      },
    );
    return data;
  },

  getAppUsageHistory: async (
    params: AppUsageHistoryParams,
  ): Promise<AdminPaginatedEnvelope<AppUsageEvent[]>> => {
    const {data} = await axios.get<AdminPaginatedEnvelope<AppUsageEvent[]>>(
      `/v2/admin/users/app-usage-history`,
      {
        params: {
          page: params.page,
          limit: params.limit,
          events: (params.events ?? Object.values(AttributionEventType)).join(
            ',',
          ),
          userId: params.userId,
          ...(params.fromDate && {fromDate: params.fromDate}),
          ...(params.toDate && {toDate: params.toDate}),
        },
      },
    );
    return data;
  },
};
